import tableSportRoomConfigs from './tableSportRoomConfigs';

export default {
  title: 'Configuration Management',
  attributeName: 'appConfigs',
  getURL: 'appId/appConfigs',
  sessionParams: ['appId'],
  noArea: true,
  tableConfig: tableSportRoomConfigs,
  autoUpdate: false,
};
